<template>
  <div>
    <!-- 顶部导航 -->
    <TopNav></TopNav>
    <!-- 居民APP轮播图 -->
    <ResidentBanner></ResidentBanner>
    <!-- 居民APP列表 -->
    <ResidentList></ResidentList>
    <!-- 居民APP物业服务 -->
    <ResidentOffice></ResidentOffice>
    <!-- 生活服务 -->
    <ResidentControl></ResidentControl>
    <!-- 智能家居 -->
    <ResidentSupervise></ResidentSupervise>
    <!-- 底部导航 -->
    <ButtonNav></ButtonNav>
  </div>
</template>

<script>
import { reactive } from "vue";

import TopNav from "../../../../components/mobile/components/TopNav.vue";
import ButtonNav from "../../../../components/mobile/components/BottomNav.vue";
import ResidentBanner from "../../../../components/mobile/Product/ResidentComponents/ResidentBanner.vue";
import ResidentList from "../../../../components/mobile/Product/ResidentComponents/ResidentList.vue";
import ResidentOffice from "../../../../components/mobile/Product/ResidentComponents/ResidentOffice.vue";
import ResidentControl from "../../../../components/mobile/Product/ResidentComponents/ResidentControl.vue";
import ResidentSupervise from "../../../../components/mobile/Product/ResidentComponents/ResidentSupervise.vue";

export default {
  setup() {
    return reactive({});
  },
  components: {
    TopNav,
    ButtonNav,
    ResidentBanner,
    ResidentList,
    ResidentOffice,
    ResidentControl,
    ResidentSupervise,
  },
};
</script>

<style scoped>
</style>
